import { postRequest } from "../api/RequestSevices";
import responseHandler from "./responseHandler";
const Logout = async () => {
  const URL = process.env.REACT_APP_LOGOUT_URL
  try {
    const { data } = await postRequest(URL);
    if (data?.status === 200) {
      return responseHandler(data, "API_SUCCESS");
    } else {
      return responseHandler(data, "API_ERROR");
    }
  } catch (err) {
    return responseHandler(err, "NETWORK_ERROR");
  }
};
export default Logout;
